import { BskyComments } from './components/bsky-comments';
import { CatCount } from './components/catCount';
import { NowListening } from './components/nowListening';
import { UpdatedAt } from './components/updatedAt';
import { handleImageUpscale } from './runtime/images';
import { RecentListens } from './components/recentListens';
import { Skeleton } from './components/skeleton';
import { Album } from './components/album';
import { LastFmScrobbler } from './components/scrobbler';
import BmsDifficulties from './components/bmsDifficulties';
import { EstrogenLevels } from './components/estrogen/estrogen-levels';
import { RecentPosts } from './components/recentPosts';
import { BskyEmbed } from './components/bsky-embed';

customElements.define('skeleton-loader', Skeleton);
customElements.define('album-artwork', Album);

customElements.define('now-listening', NowListening);
customElements.define('cat-count', CatCount);
customElements.define('updated-at', UpdatedAt);
customElements.define('bsky-comments', BskyComments);
customElements.define('recent-listens', RecentListens);
customElements.define('bms-difficulties', BmsDifficulties);
customElements.define('estrogen-levels', EstrogenLevels);
customElements.define('recent-posts', RecentPosts);
customElements.define('bsky-embed', BskyEmbed);

customElements.define('last-fm-scrobbler', LastFmScrobbler);

handleImageUpscale();
